enum AnswerTypeEnum {
  Child = "Child",
  Parent = "Parent",
}

export default AnswerTypeEnum;
